module.exports = __webpack_public_path__ + "567bb586977eee52e69458cf8b2470ff.gif";